import {
    Button,
    Title,
    TextField,
    Icon,
    RadioButton,
    PageLoader,
} from '../../../common';
import { TeamUser, UserReportTypes } from '../../../../utils/types';
import { COLOURS } from '../../../../utils/consts';

import './reportUserDialog.css';
import { useReportUserDialog } from './useReportUserDialog';
import { useState } from 'react';

interface DialogProps {
    isOpen: boolean;
    eventId: string;
    user: TeamUser;
    bodyText: string;
    onClose: () => void;
    onReportUser: () => void;
}

const ReportUserDialog: React.FC<DialogProps> = ({
    isOpen,
    eventId,
    user,
    onClose,
    onReportUser,
}) => {
    const { reportUser, isReportLoading } = useReportUserDialog(eventId);
    const [reportType, setReportType] = useState<UserReportTypes>(
        UserReportTypes.NO_SHOW
    );

    if (!isOpen) {
        return null;
    }

    function onReportTypeChange(selectedOption: string) {
        setReportType(selectedOption as UserReportTypes);
    }

    const reportUserHandler = async () => {
        await reportUser(user.id, reportType);
        onReportUser();
    };

    return (
        <div className="dialog-overlay">
            <div className="dialog-container">
                <div className="dialog-header red">
                    <Icon
                        name="bx-x"
                        color={COLOURS.gray}
                        size="30px"
                        cursor="pointer"
                        onClick={onClose}
                    />
                    <Title text={`Report user ${user.username}`}></Title>
                </div>
                <div className="report-user-dialog-body">
                    {isReportLoading ? (
                        <PageLoader />
                    ) : (
                        <div className="">
                            <RadioButton
                                label="Select a report type"
                                color="red"
                                onChange={onReportTypeChange}
                                checked={false}
                                options={[
                                    {
                                        name: UserReportTypes.NO_SHOW,
                                        title: 'No Show',
                                        tooltip:
                                            'Report this user for not showing up at the event',
                                    },
                                    {
                                        name: UserReportTypes.MISCONDUCT,
                                        title: 'Misconduct',
                                        tooltip:
                                            'Report this user inappropriate behaviour.',
                                    },
                                ]}
                            />
                            <div className="report-user-dialog-text">
                                <Icon name="bx-error" color={COLOURS.RED} />
                                <TextField color="red">
                                    Think carefully before submitting a report.
                                    Doing so may impact this user’s eligibility
                                    for upcoming events.
                                </TextField>
                            </div>
                        </div>
                    )}
                </div>
                <div className="dialog-footer">
                    <Button
                        type="button"
                        text="Cancel"
                        onClick={onClose}
                        disabled={isReportLoading}
                        size="lg"
                    />
                    <Button
                        type="button"
                        text="Confirm"
                        variant="red"
                        onClick={reportUserHandler}
                        disabled={isReportLoading}
                        size="lg"
                    />
                </div>
            </div>
        </div>
    );
};

export default ReportUserDialog;
